export const LOAD_MOBILE_INSTALLED_APPS_DATA = 'LOAD_MOBILE_INSTALLED_APPS_DATA';
export type LOAD_MOBILE_INSTALLED_APPS_DATA = typeof LOAD_MOBILE_INSTALLED_APPS_DATA;

export interface MobileInstalledAppsDataLoadAction {
    type: LOAD_MOBILE_INSTALLED_APPS_DATA;
    editorId: string;
    shouldValueBeSaved: boolean;
}

export function loadMobileInstalledAppsData(
    editorId: string,
    shouldValueBeSaved: boolean = false
): MobileInstalledAppsDataLoadAction {
    return {
        type: LOAD_MOBILE_INSTALLED_APPS_DATA,
        editorId,
        shouldValueBeSaved
    };
}
